// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2PqLp","header":"Messages_header__2rwhU"};